let Notifications = null;

if ("Notification" in window) {
    Notifications = window.Notification;
}
export default Notifications;